import { Component, HostBinding, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

import { pageTransitions } from '../../../../../../../shared/animations/page-transitions';
import { OrganizationDetails } from '../../../../../../models/organization';
import { AddSubOrganizationService } from '../../../../../../services/add-suborg.service';

@Component({
	selector: 'copo-step-confirm-suborg',
	templateUrl: './step-confirm-suborg.component.html',
	styleUrl: './step-confirm-suborg.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [TranslateModule],
})
export class StepConfirmSubOrgComponent implements OnDestroy {
	@HostBinding('class.passthrough') readonly passthrough = true;
	userFirstName?: string;
	userLastName?: string;
	email?: string;
	organizationName?: string;
	currentSelectedOrg?: OrganizationDetails;
	vatNumber?: string;
	sub?: Subscription;
	isLoading = true;
	constructor(
		private readonly addSubOrgService: AddSubOrganizationService
	) {
		this.sub = this.addSubOrgService.userFirstName.subscribe(userFirstName => {
			this.userFirstName = userFirstName;
		});

		this.sub = this.addSubOrgService.userLastName.subscribe(userLastName => {
			this.userLastName = userLastName;
		});
		this.sub = this.addSubOrgService.email
			.subscribe(email => {
				this.email = email;
			});
		this.sub = this.addSubOrgService.currentSelectedOrg.subscribe(selectedOrg => {
			this.currentSelectedOrg = selectedOrg;
		});

		if (!this.currentSelectedOrg) {
			this.sub = this.addSubOrgService.organizationName
				.subscribe(organizationName => {
					this.organizationName = organizationName;
				});
			this.sub = this.addSubOrgService.vatNumber
				.subscribe(vatNumber => {
					this.vatNumber = vatNumber;
				});
		} else {
			this.organizationName = this.currentSelectedOrg.name;
			this.vatNumber = this.currentSelectedOrg.vatNumber;
		}
	}

	ngOnDestroy() {
		if (this.sub !== undefined) {
			this.sub.unsubscribe();
		}
	}
}
